import React from "react";
import Navbar from "../components/Navbar/Navbar";
import SideNav from "../components/Dashboard/SideNav/SideNav";

const Dashboard = () => {
   const isAdmin = localStorage.getItem("isAdmin");
   return (
      <div>
         {isAdmin && (
            <>
               <Navbar />
               <SideNav />
            </>
         )}
      </div>
   );
};

export default Dashboard;
